import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { DurumGuncellemeEditComponent } from './durum-guncelleme-edit.component';
import { DurumGuncellemeKartComponent } from './durum-guncelleme-kart.component';

@DinamikBilesen({
  id: 'durum-guncelleme',
  baslik: 'Durum Güncellemesi',
  aciklama: 'Bakım talebi durum güncelleme',
  ikon: 'sync',
  kategori: 'bakim',
})
class DurumGuncelleme {
  paylas_kutusu = DurumGuncellemeEditComponent;
  paylasilmis_kart = DurumGuncellemeKartComponent;
}
